import { API, axios, SendRequest, toastr} from '@/imports-files/pages/clients/activities/client-integrations';


export class ClientIntegration extends SendRequest 
{

  async getIntegrationsList(params) 
  {
    const url = API.client.activities.CLIENT_INTEGRATIONS_URL;
    try {
      const result = await axios.get( url,
          {
            params: params,
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }


  async updateIntegrationAccessibility(params, integration_id){
    const url = API.client.activities.INTEGRATION_ACCESSIBILITY_URL.replace('$integration_id', integration_id);
    try {
      const result = await axios.post( url,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async disconnectIntegration(params, integration_id){
    const url = API.client.activities.DISCONNECT_INTEGRATION.replace('$integration_id', integration_id);
    try {
      const result = await axios.delete( url,
          {
            params: params,
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }


  async getCustomIntegrationsList()
  {
     const url = API.client.activities.CUSTOM_INTEGRATIONS;
      try {
        const result = await axios.get( url,
            {
              headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
      } catch (error) {
        return error;
      }
  }


}